import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class GuidColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'Guid';
    }
}
